"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectSportControl = void 0;

var _atoms = require("../../../atoms");

require("./SelectSportControl.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Drew Burnett
 */
// Imports
// Select Sport Control
var SelectSportControl = function SelectSportControl(_ref) {
  var sports = _ref.sports,
      selectedSport = _ref.selectedSport,
      onSelectSport = _ref.onSelectSport,
      buttonsDisabled = _ref.buttonsDisabled,
      onDisabledSelectSport = _ref.onDisabledSelectSport;

  var handleOnSportClick = function handleOnSportClick(e, sport) {
    if (typeof onSelectSport === "function" && !buttonsDisabled) {
      onSelectSport(sport);
    } else if (typeof onSelectSport === "function" && buttonsDisabled) {
      onDisabledSelectSport(sport);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "SelectSportControl",
    padding: "4",
    width: "100%"
  }, sports.map(function (sport) {
    var cn = sport === selectedSport ? "sport-type selected" : "sport-type";
    return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center",
      justifyContent: "space-between",
      onClick: function onClick(e) {
        return handleOnSportClick(e, sport);
      },
      className: cn,
      marginBottom: "4",
      width: "100%"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      className: "spacer"
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      bold: true
    }, sport), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      justifyContent: "center",
      alignItems: "center",
      className: "icon-container"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 24,
      type: _atoms.Icon.Type.CheveronRight,
      color: _atoms.Color.Grey3
    })));
  }));
};

exports.SelectSportControl = SelectSportControl;